import React, { FC } from 'react'
import { IInputProps } from '../../../modules/form'

export const InputText: FC<IInputProps> = ({ onChange, onTouched, value, name, isDisabled, inputRef, defaultValue, placeholder }) => {
    return (
        <input
            id={name}
            type="text"
            onChange={e => onChange(e.target.value)}
            onBlur={() => onTouched()}
            value={value}
            disabled={isDisabled}
            defaultValue={defaultValue}
            ref={inputRef}
            placeholder={placeholder}
        />
        
    )
}